import { INIT_FILES, ADD_FILES, REMOVE_FILES } from '../type';

export function filesReducer(state = [], action) {
  const { type, payload } = action;

  switch (type) {
    case INIT_FILES: {
      return payload;
    }
    case ADD_FILES: {
      return payload;
    }

    case REMOVE_FILES: {
      return payload;
    }
    default:
      return state;
  }
}
